import { render, staticRenderFns } from "./OrderSubmissionCustomerInfo.vue?vue&type=template&id=f434f0ae&scoped=true&"
import script from "./OrderSubmissionCustomerInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderSubmissionCustomerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSubmissionCustomerInfo.vue?vue&type=style&index=0&id=f434f0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f434f0ae",
  null
  
)

export default component.exports